import { useAuth } from '@/contexts'
import { useQuery } from '@tanstack/react-query'

export const useUser = () => {
    const baseUrl = `${import.meta.env.VITE_API_URL}/api/users/`

    const { session, user, getAccessToken } = useAuth()
    const userData = useQuery({
        queryKey: [user?.id],
        queryFn: async () => {
            const response = await fetch(`${baseUrl}${user?.id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: (await getAccessToken()) || '',
                },
            })

            if (!response.ok) {
                throw new Error(response.statusText)
            }

            return response.json()
        },
        enabled: !!user?.id && !!session,
    })

    return {
        isLoading: userData.isLoading,
        userData: userData.data,
    }
}
